<template>
  <div style="background: #ffffff;border-radius: 8px;padding: 12px 24px 24px 24px">
    <div class="fontSize20gay text-left">每日巡检自查</div>
    <div style="border-bottom: 1px solid #EBEBEB;border-top: 1px solid #EBEBEB;margin-top: 16px;padding: 36px 0">
      <div style="width: 800px;margin: auto">
        <el-form :model="pageForm" :rules="pageFormRules" ref="formRef">
          <el-form-item label="日期" prop="date" size="large" label-width="160px">
            <el-date-picker v-model="pageForm.date"
                            type="date"
                            size="large"
                            placeholder="请选择日期"
                            value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="实验室" prop="laboratoryId" size="large" label-width="160px">
            <el-select v-model="pageForm.laboratoryId"
                       filterable
                       class="room-select-tl"
                       placeholder="选择实验室"
                       size="large">
              <el-option v-for="item in laboratoryList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备仪器状态" prop="equipmentState" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.equipmentState" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电源" prop="power" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.power" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="水源" prop="water" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.water" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="门窗" prop="door" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.door" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="卫生" prop="health" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.health" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="桌椅" prop="chair" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.chair" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="环境" prop="environment" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.environment" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="照明" prop="light" size="large" label-width="160px">
            <el-radio-group v-model="pageForm.light" class="ml-4">
              <el-radio label="1" size="large">合格</el-radio>
              <el-radio label="0" size="large">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="巡检员" prop="userId" size="large" label-width="160px">
            <el-select v-model="pageForm.userId"
                       filterable
                       class="room-select-tl"
                       placeholder="搜索巡检员"
                       size="large"
                       remote
                       :remote-method="getUserList"
                       @change="selectChange">
              <el-option v-for="item in teacherList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
              <template #prefix>
                <div>
                  {{ teacher.code }}
                </div>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="现场照片" prop="image" size="large" label-width="160px">
            <image-list ref="imageList"></image-list>
          </el-form-item>
          <el-form-item label="备注" prop="notes" size="large" label-width="160px">
            <el-input v-model="pageForm.notes"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="marginTop15px">
      <button class="subBtn" @click="subData">保存</button>
      <button class="qxBtn" @click="qxBtn">取消</button>
    </div>
  </div>
</template>

<script>
import {getAllLaboratory, getTeacherList, setDayPage} from "@/api/examination";
import ImageList from "@/view/patrolInspection/ImageList";

export default {
  name: "laboratoryEquipment",
  components: {ImageList},
  data(){
    return {
      teacherList: [],
      teacher: {},
      laboratoryList: [],
      pageForm: {
        // 日期
        date: '',
        // 实验室名称
        laboratoryId: '',
        // 设备仪器状态
        equipmentState: '1',
        // 电源
        power: '1',
        // 水源
        water: '1',
        // 门窗
        door: '1',
        // 卫生
        health: '1',
        // 桌椅
        chair: '1',
        // 环境
        environment: '1',
        // 照明
        light: '1',
        // 巡检人员
        userId: '',
        // 备注
        notes: '',
        // 现场照片 img: '',
      },
      pageFormRules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'blur' },
        ],
        laboratoryId: [
          { required: true, message: '请选择实验室', trigger: 'blur' },
        ],
        // 设备仪器状态
        equipmentState: [
          { required: true, message: '请检验 设备仪器状态 是否合格', trigger: 'blur' },
        ],
        // 电源
        power: [
          { required: true, message: '请检验 电源 是否合格', trigger: 'blur' },
        ],
        // 水源
        water: [
          { required: true, message: '请检验 水源 是否合格', trigger: 'blur' },
        ],
        // 门窗
        door: [
          { required: true, message: '请检验 门窗 是否合格', trigger: 'blur' },
        ],
        // 卫生
        health: [
          { required: true, message: '请检验 卫生 是否合格', trigger: 'blur' },
        ],
        // 桌椅
        chair: [
          { required: true, message: '请检验 桌椅 是否合格', trigger: 'blur' },
        ],
        // 环境
        environment: [
          { required: true, message: '请检验 环境 是否合格', trigger: 'blur' },
        ],
        // 照明
        light: [
          { required: true, message: '请检验 照明 是否合格', trigger: 'blur' },
        ],
        userId: [
          { required: true, message: '请选择巡检员', trigger: 'blur' },
        ],
      },
      id: null,
    }
  },
  mounted() {
    this.init();
    let data=this.$root.useRoute.query;
    if(data.info){
      this.pageForm=JSON.parse(data.info);
      this.$refs.imageList.setImageInfo(this.pageForm.img);
      if(this.pageForm && this.pageForm.teacher) {
        this.getUserList(this.pageForm.teacher.name);
      }
    }
  },
  methods: {
    selectChange(e){
      this.teacher = this.teacherList.find(iter => iter.id == e) || {}
    },
    init(){
      getAllLaboratory().then(res => {
        if (res.success) {
          this.laboratoryList = res.data
        } else {
          this.$root.ElMessage.error(res.message)
        }
      })
    },
    getUserList(keyword){
      if (keyword) {
        getTeacherList({ name: keyword }).then(res => {
          if (res.success) {
            this.teacherList = res.data
            console.log(this.teacherList);
          } else {
            this.$root.ElMessage.error(res.message)
          }
        })
      }
    },
    getTeachers(){

    },
    subData(){
      this.$refs.formRef.validate((valid, error) => {
        if (valid) {
          const handler = setDayPage
          let method='post';
          if(this.pageForm.id){method='put'}
          // 追加现场照片
          handler({ ...this.pageForm, img: this.$refs.imageList.getImg()},method).then(res => {
            if(res.success){
              this.$root.ElMessage({type:'success',message:res.message});
              setTimeout(() => {
                this.$root.useRouter.replace('/patrolInspection/patrolInspectionList')
              }, 500)
            }else{
              this.$root.ElMessage.error(res.message);
            }
          })
        } else {
          const key = Object.keys(error)[0]
          const msg = error[key][0].message
          this.$root.ElMessage.error(msg)
        }
      })
    },
    qxBtn(){
      this.$root.useRouter.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>